import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getDevices, getAlertEvents } from '../api/alertApi';
import StatusBadge from '../components/StatusBadge';

export default function AlertHistory() {
  const [deviceId, setDeviceId] = useState('');
  const [page, setPage] = useState(1);

  const { data: devicesData } = useQuery({ queryKey: ['devices'], queryFn: getDevices });
  const { data, isLoading }   = useQuery({
    queryKey: ['events', deviceId, page],
    queryFn: () => getAlertEvents(deviceId || null, { page, limit: 25 }),
  });

  const devices = devicesData?.data || [];
  const events  = data?.data || [];
  const meta    = data?.meta || {};

  return (
    <div>
      <h1 style={{ marginBottom: 20 }}>Alert History</h1>

      <div style={{ display: 'flex', gap: 12, marginBottom: 20 }}>
        <select value={deviceId} onChange={e => { setDeviceId(e.target.value); setPage(1); }} style={sel}>
          <option value="">All Devices</option>
          {devices.map(d => <option key={d.device_id} value={d.device_id}>{d.name} ({d.device_id})</option>)}
        </select>
      </div>

      {isLoading ? <p>Loading…</p> : (
        <>
          <table style={tbl}>
            <thead>
              <tr>
                {['#', 'Device', 'Rule', 'Parameter', 'Condition', 'Value', 'Threshold', 'Severity', 'Time'].map(h => (
                  <th key={h} style={th}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {events.map(e => (
                <tr key={e.id} style={{ background: e.severity === 'critical' ? '#fff5f5' : 'transparent' }}>
                  <td style={td}>{e.id}</td>
                  <td style={td}><code>{e.device_id}</code></td>
                  <td style={td}>{e.rule?.rule_name || `Rule #${e.rule_id}`}</td>
                  <td style={td}>{e.parameter}</td>
                  <td style={td}>{e.condition_type}</td>
                  <td style={td}>{e.actual_value ?? '—'}</td>
                  <td style={td}>
                    {e.condition_type === 'between' || e.condition_type === 'outside'
                      ? `${e.threshold_min} – ${e.threshold_max}`
                      : e.condition_type === 'no_data'
                      ? `${e.no_data_minutes} min`
                      : (e.threshold_value ?? '—')}
                  </td>
                  <td style={td}><StatusBadge value={e.severity} /></td>
                  <td style={{ ...td, whiteSpace: 'nowrap' }}>{new Date(e.triggered_at).toLocaleString()}</td>
                </tr>
              ))}
              {events.length === 0 && (
                <tr><td colSpan={9} style={{ ...td, textAlign: 'center', color: '#9ca3af' }}>No alert events found</td></tr>
              )}
            </tbody>
          </table>

          {meta.total > 25 && (
            <div style={{ display: 'flex', gap: 8, marginTop: 16, justifyContent: 'center' }}>
              <button style={pgBtn} disabled={page === 1} onClick={() => setPage(p => p - 1)}>← Prev</button>
              <span style={{ lineHeight: '34px', fontSize: 14 }}>Page {meta.page} of {Math.ceil(meta.total / meta.limit)}</span>
              <button style={pgBtn} disabled={page * meta.limit >= meta.total} onClick={() => setPage(p => p + 1)}>Next →</button>
            </div>
          )}
        </>
      )}
    </div>
  );
}

const tbl   = { width: '100%', borderCollapse: 'collapse', fontSize: 13, background: '#fff' };
const th    = { padding: '8px 10px', background: '#f3f4f6', textAlign: 'left', fontWeight: 600 };
const td    = { padding: '8px 10px', borderBottom: '1px solid #e5e7eb' };
const sel   = { padding: '8px 12px', borderRadius: 6, border: '1px solid #d1d5db', fontSize: 14, minWidth: 220 };
const pgBtn = { padding: '6px 14px', borderRadius: 6, border: '1px solid #d1d5db', cursor: 'pointer', background: '#fff' };
